var _rect, _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgChart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 27,
    height: 27,
    rx: 1.5,
    stroke: "#6164BA",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 8.906v2.037h10V8.906H3zm-2-3a1 1 0 00-1 1v6.037a1 1 0 001 1h14a1 1 0 001-1V6.906a1 1 0 00-1-1H1z",
    clipRule: "evenodd",
    fill: "#6164BA",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 13.965v2.037h17v-2.037H3zm-2-3a1 1 0 00-1 1v6.037a1 1 0 001 1h21a1 1 0 001-1v-6.037a1 1 0 00-1-1H1z",
    clipRule: "evenodd",
    fill: "#6164BA",
    fillRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3 19.058v2.037h5v-2.037H3zm-2-3a1 1 0 00-1 1v6.037a1 1 0 001 1h9a1 1 0 001-1v-6.037a1 1 0 00-1-1H1z",
    clipRule: "evenodd",
    fill: "#6164BA",
    fillRule: "evenodd"
  })));
}

export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyBmaWxsPSJub25lIiB2aWV3Qm94PSIwIDAgMzAgMzAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxyZWN0IHg9IjEuNSIgeT0iMS41IiB3aWR0aD0iMjciIGhlaWdodD0iMjciIHJ4PSIxLjUiIHN0cm9rZT0iIzYxNjRCQSIgc3Ryb2tlLXdpZHRoPSIzIi8+CjxwYXRoIGQ9Im0zIDguOTA2MnYyLjAzNjRoMTB2LTIuMDM2NGgtMTB6bS0yLTNjLTAuNTUyMjggMC0xIDAuNDQ3NzEtMSAxdjYuMDM2NGMwIDAuNTUyMyAwLjQ0NzcyIDEgMSAxaDE0YzAuNTUyMyAwIDEtMC40NDc3IDEtMXYtNi4wMzY0YzAtMC41NTIyOC0wLjQ0NzctMS0xLTFoLTE0eiIgY2xpcC1ydWxlPSJldmVub2RkIiBmaWxsPSIjNjE2NEJBIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz4KPHBhdGggZD0ibTMgMTMuOTY1djIuMDM2NWgxN3YtMi4wMzY1aC0xN3ptLTItM2MtMC41NTIyOCAwLTEgMC40NDc4LTEgMXY2LjAzNjVjMCAwLjU1MjMgMC40NDc3MiAxIDEgMWgyMWMwLjU1MjMgMCAxLTAuNDQ3NyAxLTF2LTYuMDM2NWMwLTAuNTUyMi0wLjQ0NzctMS0xLTFoLTIxeiIgY2xpcC1ydWxlPSJldmVub2RkIiBmaWxsPSIjNjE2NEJBIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz4KPHBhdGggZD0ibTMgMTkuMDU4djIuMDM2NWg1di0yLjAzNjVoLTV6bS0yLTNjLTAuNTUyMjggMC0xIDAuNDQ3Ny0xIDF2Ni4wMzY1YzAgMC41NTIyIDAuNDQ3NzIgMSAxIDFoOWMwLjU1MjMgMCAxLTAuNDQ3OCAxLTF2LTYuMDM2NWMwLTAuNTUyMy0wLjQ0NzctMS0xLTFoLTl6IiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGZpbGw9IiM2MTY0QkEiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPgo8L3N2Zz4K";
export { SvgChart as ReactComponent };